import {
  componentResize,
  componentCheckSize,
} from "../../../utils/helperServices";
import config from "../../../config/index";
import Slider from "../../atoms/slider/Slider";
import FilterItems from "../filterItems/FilterItems";
import * as FIXED from "../../../config/constants";
import styles from "./DealSliderFilter.module.scss";

const DealSliderFilter = (props) => {
  const isMobile = componentResize();
  const isTablet = componentCheckSize() <= 992;
  const imagePrefix = config.envConfigs[config.env].imagePrefix;
  const infoIconPath = `${imagePrefix}/assets/images/icon-info-grey.svg`;

  const onSliderChange = (value) => {
    if (props.type === "price") {
      props.selectPrice(value);
    }
    if (props.type === "budget") {
      props.handlePrice(value);
    }
    if (props.type === "data" || props.type === "datavmairtime") {
      props.selectData(value);
    }
    if (props.type === "airtime") {
      props.selectAirTime(value);
    }
    if (props.type === "vm") {
      props.selectVoiceMinutes(value);
    }
  };

  const displayDataVmAirtime = () => {
    let str = "";
    if (props?.dispalyDataValue) {
      str += `${props.min}GB-${props.max}GB`;
    }

    if (props?.dispalyVmValue) {
      const rightLabel =
        props.maxVm == props.maxValueVm ? "Unlimited" : `${props.maxVm}min`;
      str +=
        str !== ""
          ? ` / ${props.minVm}min-${rightLabel}`
          : `${props.minVm}min-${rightLabel}`;
    }

    if (props?.dispalyAirtimeValue) {
      str +=
        str !== ""
          ? ` / R${props.minAir}-R${props.maxAir}`
          : `R${props.minAir}-R${props.maxAir}`;
    }
    return str;
  };

  const handleDisplayValue = (type) => {
    let maxVm = "Unlimited";
    let maxAirtime = FIXED.MAX_AIRTIME;

    if ((type == "vm" || type == "Voice") && props.max == props.maxValue) {
      return `${props.min}min-${maxVm}`;
    } else {
      maxVm = props.max;
    }

    if (type == "airtime" && props.max == props.maxValue) {
      return `R${props.min}-R${maxAirtime}`;
    } else {
      maxAirtime = props.max;
    }

    switch (type) {
      case "data":
        return `${props.min}GB-${props.max}GB`;
      case "vm":
        return `${props.min}min-${maxVm}min`;
      case "airtime":
        return `R${props.min}-R${maxAirtime}`;
      case "datavmairtime":
        return displayDataVmAirtime();
      default:
        return `R${props.min} PM - R${props.max} PM`;
    }
  };

  return (
    <div>
      {isMobile || isTablet ? null : (
        <p className={props.heading ? styles.priceHeading : ""}>
          {props.heading}
        </p>
      )}
      <div
        className={
          props.isDealSelectionPage ? styles.hideSliderDeal : styles.hideSlider
        }
      >
        <Slider
          min={Math.round(props.min)}
          max={Math.round(props.max)}
          minValue={Math.round(props.minValue)}
          maxValue={Math.round(props.maxValue)}
          sliderChange={onSliderChange}
          sliderType={props.type}
          valueRange={props.valueRange}
          missingValueRange={props.missingValueRange}
          step={1}
          label1={
            props.type == "price" || props.type == "budget"
              ? "R"
              : props.type == "airtime"
              ? "R"
              : ""
          }
          label2=""
          rightLabel={
            props.type == "price" || props.type == "budget"
              ? "PM"
              : props.type == "data"
              ? "GB"
              : props.type == "vm"
              ? "min"
              : props.type == "airtime"
              ? ""
              : ""
          }
          unlimited={
            props.type === "vm" ||
            props.sliderType === "vm" ||
            props.type === "Voice"
          }
        />
      </div>
      {props.type !== "budget" ? (
        <FilterItems
          heading={props.heading}
          handleClick={props.price}
          id={
            props?.displaySlider == true && props.type
              ? `filtered_${props.type}`
              : null
          }
          renderFun={handleDisplayValue(props.type)}
        />
      ) : (
        ""
      )}
      {props.showQualifyDeals && (
        <div className={styles["info"]}>
          <img src={infoIconPath} className={styles["info-icon"]} />
          <label className={styles["info-label"]}>{props.qualifyLabel}</label>
        </div>
      )}
    </div>
  );
};

export default DealSliderFilter;
